import { AssistantContextSubType } from '../types.js';
import isString from '../../../node_modules/lodash-es/isString.js';

const folderScope = [
  AssistantContextSubType.Connection,
  AssistantContextSubType.Folder,
  AssistantContextSubType.Space
];
const resourceScope = [
  AssistantContextSubType.File,
  AssistantContextSubType.Selection
];
const convertAssistantContextToAPIScope = (contextOption) => {
  if (folderScope.includes(contextOption.subType) && isString(contextOption.value)) return {
    scope: "folder",
    folderId: contextOption.value
  };
  if (resourceScope.includes(contextOption.subType) && Array.isArray(contextOption.value)) return {
    scope: "resource",
    resourceIds: contextOption.value
  };
  return {
    scope: "user"
  };
};

export { convertAssistantContextToAPIScope };
//# sourceMappingURL=convertAssistantContextToAPIScope.js.map
